var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTell1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.073,
    height: 10.073,
    viewBox: "0 0 10.073 10.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "call-24",
    d: "M111.717,109.115a5.491,5.491,0,0,1-1.847-.294.805.805,0,0,0-.755.168l-1.175.881A6.427,6.427,0,0,1,105,106.933l.881-1.175a.73.73,0,0,0,.168-.755,6.793,6.793,0,0,1-.294-1.847A.752.752,0,0,0,105,102.4h-1.847a.752.752,0,0,0-.755.755,9.35,9.35,0,0,0,9.317,9.317.752.752,0,0,0,.755-.755v-1.889a.745.745,0,0,0-.755-.713Z",
    transform: "translate(-102.4 -102.399)",
    fill: "#797979"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTell1);
export default __webpack_public_path__ + "static/media/tell-1.becba9552e3cdf4d431e9b345b4809ab.svg";
export { ForwardRef as ReactComponent };